export const Logo = ({ size = 30 }) => (
  <span className="inline-flex items-center gap-2.5 select-none">
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <rect width="64" height="64" rx="14" fill="rgba(255,255,255,0.06)" />
      <path
        d="M32 9c9.5 11.5 15 19 15 27a15 15 0 1 1-30 0c0-8 5.5-15.5 15-27z"
        fill="#00F2FE"
      />
      <path
        d="M25 37c0-6 3.5-11 7-15"
        stroke="#07090B"
        strokeWidth="3.5"
        strokeLinecap="round"
        opacity="0.85"
      />
    </svg>
    <span className="font-display font-bold tracking-tight text-lg leading-none">
      fullshine<span className="text-aqua">.detailing</span>
    </span>
  </span>
);
